import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "right-item" }
const _hoisted_2 = {
  key: 0,
  class: "right-item__input-year-month-header input-year-month-header"
}
const _hoisted_3 = { class: "input-year-month-header__title" }
const _hoisted_4 = { class: "input-year-month-header__title--text" }
const _hoisted_5 = { class: "input-year-month-header__content header-input" }
const _hoisted_6 = { class: "header-input__label" }
const _hoisted_7 = { class: "header-input__input-text" }
const _hoisted_8 = ["value", "placeholder"]
const _hoisted_9 = {
  key: 0,
  class: "header-input__input-text--error"
}
const _hoisted_10 = {
  key: 1,
  class: "header-input__input-text--error"
}
const _hoisted_11 = { class: "right-item__input-year-month-period input-year-month-period" }
const _hoisted_12 = { class: "input-year-month-period__title" }
const _hoisted_13 = { class: "input-year-month-period__title--text" }
const _hoisted_14 = { class: "input-year-month-period__notice" }
const _hoisted_15 = { class: "input-year-month-period__content period-input" }
const _hoisted_16 = { class: "period-input__start" }
const _hoisted_17 = { class: "period-input__label" }
const _hoisted_18 = { class: "period-input__input-text" }
const _hoisted_19 = ["value", "placeholder"]
const _hoisted_20 = {
  key: 0,
  class: "header-input__input-text--error"
}
const _hoisted_21 = {
  key: 1,
  class: "header-input__input-text--error"
}
const _hoisted_22 = {
  key: 2,
  class: "header-input__input-text--error"
}
const _hoisted_23 = {
  key: 3,
  class: "header-input__input-text--error"
}
const _hoisted_24 = { class: "period-input__end" }
const _hoisted_25 = { class: "period-input__label" }
const _hoisted_26 = { class: "period-input__input-text" }
const _hoisted_27 = ["value", "placeholder"]
const _hoisted_28 = {
  key: 0,
  class: "header-input__input-text--error"
}
const _hoisted_29 = {
  key: 1,
  class: "header-input__input-text--error"
}
const _hoisted_30 = {
  key: 2,
  class: "header-input__input-text--error"
}
const _hoisted_31 = { class: "right-item__input-year-month-period input-year-month-period" }
const _hoisted_32 = { class: "input-year-month-period__title" }
const _hoisted_33 = { class: "input-year-month-period__title--text" }
const _hoisted_34 = { class: "input-year-month-period__content period-input" }
const _hoisted_35 = { class: "period-input__start" }
const _hoisted_36 = { class: "period-input__label" }
const _hoisted_37 = { class: "period-input__input-text" }
const _hoisted_38 = ["value"]
const _hoisted_39 = {
  key: 0,
  class: "header-input__input-text--error"
}
const _hoisted_40 = {
  key: 1,
  class: "header-input__input-text--error"
}
const _hoisted_41 = {
  key: 2,
  class: "header-input__input-text--error"
}
const _hoisted_42 = {
  key: 3,
  class: "header-input__input-text--error"
}
const _hoisted_43 = { class: "period-input__end" }
const _hoisted_44 = { class: "period-input__label" }
const _hoisted_45 = { class: "period-input__input-text" }
const _hoisted_46 = ["value"]
const _hoisted_47 = {
  key: 0,
  class: "header-input__input-text--error"
}
const _hoisted_48 = {
  key: 1,
  class: "header-input__input-text--error"
}
const _hoisted_49 = {
  key: 2,
  class: "header-input__input-text--error"
}

import { onMounted, ref, watch } from 'vue';
import { i18n } from '@/i18n';
import HelpIconWithModal from '@/corePagesModule/components/HelpIconWithModal.vue';
import { storeToRefs } from 'pinia';
import { SelectYearMonthPatternInHeader, SelectYearMonthPatternInlined } from '../../interfaces/LinkingInput';
import { SelectYearMonthPattern } from '../../interfaces/UploadFile';

export default /*@__PURE__*/_defineComponent({
  __name: 'InputExcelYearMonthInfo',
  props: {
    selectYearMonthPattern: {},
    inlinedYearMonthInfo: {},
    inHeaderYearMonthInfo: {}
  },
  emits: ["update-inline-header-name", "update-in-header-start-column-number", "update-in-header-end-column-number", "update-in-header-start", "update-in-header-end"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;
const props = __props;

const emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.selectYearMonthPattern === 'Inlined')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('年月情報がある入力エクセルのヘッダー名を記入してください')), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('年月')), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("input", {
                value: _ctx.inlinedYearMonthInfo.headerName,
                class: "header-input__input-text--form",
                type: "text",
                placeholder: _unref(t)('記入してください'),
                onChange: _cache[0] || (_cache[0] = ($event: any) => (emits('update-inline-header-name', ($event.target as HTMLInputElement).value)))
              }, null, 40, _hoisted_8)
            ]),
            (_ctx.inlinedYearMonthInfo.validateError === 'notEmpty')
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(t)('記入必須です')), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString('　')))
          ])
        ]))
      : (_ctx.selectYearMonthPattern === 'InHeader')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('取込開始と終了の入力エクセルの列番号を記入してください')), 1)
              ]),
              _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)('＊複数月を入力する場合、列は隣り合っている必要があります。')), 1),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)('取込開始年月の列番号')), 1),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("input", {
                      value: _ctx.inHeaderYearMonthInfo.startColumnNumber.raw,
                      class: "period-input__input-text--form",
                      type: "text",
                      placeholder: _unref(t)('半角英数のみ'),
                      onChange: _cache[1] || (_cache[1] = ($event: any) => (emits('update-in-header-start-column-number', ($event.target as HTMLInputElement).value)))
                    }, null, 40, _hoisted_19)
                  ]),
                  (_ctx.inHeaderYearMonthInfo.startColumnNumber.validateError === 'notEmpty')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(t)('記入必須です')), 1))
                    : (_ctx.inHeaderYearMonthInfo.startColumnNumber.validateError === 'cellPattern')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(t)('A, BBのような形式で記入してください')), 1))
                      : (_ctx.inHeaderYearMonthInfo.startColumnNumber.validateError === 'sideBySideCell')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_unref(t)('取込開始年月より右側の列番号を取込終了年月に指定してください。')), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString('　')))
                ]),
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "period-input__duration" }, "〜", -1)),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(t)('取込終了年月の列番号')), 1),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("input", {
                      value: _ctx.inHeaderYearMonthInfo.endColumnNumber.raw,
                      class: "period-input__input-text--form",
                      type: "text",
                      placeholder: _unref(t)('半角英数のみ'),
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (emits('update-in-header-end-column-number', ($event.target as HTMLInputElement).value)))
                    }, null, 40, _hoisted_27)
                  ]),
                  (_ctx.inHeaderYearMonthInfo.endColumnNumber.validateError === 'notEmpty')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_unref(t)('記入必須です')), 1))
                    : (_ctx.inHeaderYearMonthInfo.endColumnNumber.validateError === 'cellPattern')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_unref(t)('A, BBのような形式で記入してください')), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString('　')))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(t)('取込開始年月と終了年月を指定してください')), 1)
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("span", _hoisted_36, _toDisplayString(_unref(t)('取込開始年月')), 1),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("input", {
                      value: _ctx.inHeaderYearMonthInfo.start.raw,
                      class: "period-input__input-text--form",
                      type: "text",
                      placeholder: "YYYYMM",
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (emits('update-in-header-start', ($event.target as HTMLInputElement).value)))
                    }, null, 40, _hoisted_38)
                  ]),
                  (_ctx.inHeaderYearMonthInfo.start.validateError === 'notEmpty')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_unref(t)('記入必須です')), 1))
                    : (_ctx.inHeaderYearMonthInfo.start.validateError === 'yearMonth')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_unref(t)('202301のような形式で記入してください')), 1))
                      : (_ctx.inHeaderYearMonthInfo.start.validateError === 'sideBySideYearMonth')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_unref(t)('取込開始年月より後に取込終了年月を指定してください。')), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString('　')))
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "period-input__duration" }, "〜", -1)),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("span", _hoisted_44, _toDisplayString(_unref(t)('取込終了年月')), 1),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("input", {
                      value: _ctx.inHeaderYearMonthInfo.end.raw,
                      class: "period-input__input-text--form",
                      type: "text",
                      placeholder: "YYYYMM",
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (emits('update-in-header-end', ($event.target as HTMLInputElement).value)))
                    }, null, 40, _hoisted_46)
                  ]),
                  (_ctx.inHeaderYearMonthInfo.end.validateError === 'notEmpty')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_unref(t)('記入必須です')), 1))
                    : (_ctx.inHeaderYearMonthInfo.end.validateError === 'yearMonth')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_unref(t)('202301のような形式で記入してください')), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString('　')))
                ])
              ])
            ])
          ], 64))
        : _createCommentVNode("", true)
  ]))
}
}

})